import { createEditor, suggest } from '@tatatap-com/sowhat-editor'
import eventBus from '@/eventBus'
import store from './store'

const theme = {
  '&.cm-editor': {
    padding: '6px',
    background: '#fff',
    fontFamily: `'Overpass Mono', monospace`,
    fontSize: '16px',
    borderRadius: '4px'
  },
  '&.cm-editor.cm-focused': {
    outline: 'none',
  },

  '&.cm-editor .cm-line': {
    fontFamily: `'Overpass Mono', monospace`,
  },

  '.cm-selectionBackground': {
    background: 'rgba(0, 200, 0, 0.3) !important',
  },
  '.cm-completionIcon': {
    display: 'none',
  },
  '.cm-tooltip': {
    background: '#fff',
    border: '1px solid #ddd',
    boxShadow: '3px 2px 18px -5px rgba(0,0,0,0.1)'
  },
  '.cm-tooltip.cm-tooltip-autocomplete > ul > li': {
    padding: '4px 6px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  '.cm-tooltip.cm-tooltip-autocomplete > ul > li[aria-selected]': {
    background: 'rgba(0, 200, 0, 0.4)',
  },
  '.cm-completionMatchedText': {
    color: 'rgba(0, 0, 0, 1)',
    textDecoration: 'none',
  },
}

export default async function ({elm, text, onSubmit, onChange, placeholder = 'Write it down...'}) {
  await store.dispatch('getElements')

  const {beans, tags, folders, events} = store.state.elements || {}

  suggest('bean', beans)
  suggest('tag', tags)
  suggest('folder', folders)
  suggest('event', events)


  eventBus.$on('after-record-sync', () => {
    const {beans, tags, folders, events} = store.state.elements || {}
    suggest('bean', beans)
    suggest('tag', tags)
    suggest('folder', folders)
    suggest('event', events)
  })

  const keys = [
    {
      key: 'Ctrl-Enter',
      run(view) {
        onSubmit()
      },
      preventDefault: true
    },
    {
      key: 'Cmd-Enter',
      run(view) {
        onSubmit()
      },
      preventDefault: true
    }
  ]

  const editor = createEditor({
    root: elm,
    initialValue: text,
    onChange,
    onFocus: () => {},
    onBlur: () => {},
    opts: {keys, theme, placeholderText: placeholder}
  });

  editor.dispatch({selection: {anchor: text.length}})

  return editor;
}
